import React from 'react';
import {
  Body,
  Headline,
  designSystemToken,
} from '@lightricks/react-design-system';
import translate from '@/utils/translate';
import styles from './UnderReviewState.module.scss';

function UnderReviewState() {
  return (
    <div className={styles.container}>
      <Headline
        size="xs"
        color={designSystemToken('semantic.fg.primary')}
        className={styles.title}
      >
        {translate('Your campaign information has been submitted!')}
      </Headline>
      <Body size="sm" color={designSystemToken('semantic.fg.secondary')}>
        {translate(
          "Hang tight, we're reviewing the brief and will be in touch in one to two working days."
        )}
      </Body>
    </div>
  );
}

export default UnderReviewState;
